import { ServiceTypes, ToUserTypings } from './Constants';
import Routes from './Routes';

const { full } = ServiceTypes;
const { pharmacist } = Routes;
const { pharmacistCalendar } = pharmacist;

const ServiceHandler = () => {
  let service = full;
  const setService = (inService: ServiceTypes) => {
    service = inService;
  };
  const getService = () => service;
  return { setService, getService };
};

export const serviceBasedRoutes = {
  pharmacistCalendar: pharmacistCalendar,
};

export const CreateTypes = ToUserTypings({
  Pharmacy: 'pharmacies',
  Pharmacist: 'pharmacists',
});

export const idStore = {
  id: 'pharmacistId',
  pharmacistNotesId: 'pharmacistPharmacyNoteId',
  pharmacyNotesId: 'pharmacyPharmacistNoteId',
  updateNotesId: 'pharmacistNotesId',
  capacityId: 'pharmacistCapacityId',
  clientRoute: Routes.admin.pharmacists,
  pictureRoute: Routes.admin.pharmacistPictures,
  adminCapacitiesList: Routes.admin.pharmacistCapacitiesList,
  adminCapacities: Routes.admin.pharmacistCapacities,
  adminClientNoteId: 'adminPharmacistNoteId',
};

export default ServiceHandler();
